<template>
    <li class="employee">
        <div class="employee__inner">
            <ResponsiveImage v-if="employee.imageForVue.src || employee.imageForVue.hasCrop" :imageModel="employee.imageForVue" wrapClass="employee__image" />
            <div class="employee__image" v-if="!employee.imageForVue && !employee.imageForVue">
                <img class="employee__image--placeholder lazyload" width="278" height="330" src="/assets/images/placeholders/placeholder_employee.png" alt="" />
            </div>
            <div class="employee__image" v-if="!employee.imageForVue && employee.imageUrl">
                <img class="employee__image lazyload" :src="`${employee.imageUrl}?width=278`" alt="" />
            </div>
            <div class="employee__info">
                <div class="employee__row">
                    <h3 class="employee__name">{{employee.name}}</h3>
                </div>
                <div class="employee__row">
                    <p class="employee__title">{{employee.title}}</p>
                    <p class="employee__country">{{employee.country}}</p>
                </div>
                <div class="employee__row">
                    <p class="employee__text" v-if="employee.phone">
                        <a :href="`tel:${employee.phone}`" class="employee__link">{{employee.phone}}</a>
                    </p>
                    <div class="employee__text" v-if="employee.email">
                        <p class="employee__mail">{{employee.email}}</p>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import ResponsiveImage from "./responsiveImage.vue";

    export default {
        name: "employee",
        components: {
        ResponsiveImage
    },
        props: ["employee"]
    };
</script>


// WEBPACK FOOTER //
// src/scripts/vue/components/employee.vue